import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './DrugsListWrite.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';
import URL from "../../../../../constants/url";
import Modal from "../../../../../components/comm/Modal"
import { useLocation, useNavigate } from 'react-router-dom';

import ToastPopup from '../../../../../components/comm/ToastPopup';


const DrugsListWrite = () => {

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const location = useLocation();
    const navigate = useNavigate();
    const mediInfo = location.state?.mediInfo;

    const [isDisabled, setIsDisabled] = useState(true);

    const [saveMediInfo , setSaveMediInfo] = useState({
        id : mediInfo.id,
        usrInfoId : mediInfo.usrInfoId,
        crrPrscmdcCn : mediInfo.crrPrscmdcCn,
        etcMdcnCn : mediInfo.etcMdcnCn,
    });
    const [saveCompleteOpen, setSaveCompleteOpen] = useState(false);  //저장완료 모달

    const handleChageText = (target) => {
        const { name, value } = target;

        setSaveMediInfo((prev) => ({ ...prev, [name]: value }));
    }


    const saveMediHlthInfo = useCallback(async () => {

        const url = "/mypage/saveMediHlthInfo";

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: jToken,
            },
        }

        await axiosApi.post(url, saveMediInfo, reqOptions)
        // await axiosApi.post(url, saveMediInfo)
        .then((res) => { 
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setSaveCompleteOpen(true);
            } else {
                setToastMessage(res.data.resultMessage);
                setToast(true);
            }
        })
        .catch(err => {
            console.error("내 의료정보 저장 중 오류 : ", err);
        })

    },[saveMediInfo])

    const handleClickSaveCompleteBtn = () => {
        setSaveCompleteOpen(false);
        navigate('/MyPageMain', { replace: true });
    }

    useEffect(() => {
            
        if(saveMediInfo.id === mediInfo.id &&
            saveMediInfo.usrInfoId === mediInfo.usrInfoId &&
            saveMediInfo.crrPrscmdcCn === mediInfo.crrPrscmdcCn &&
            saveMediInfo.etcMdcnCn === mediInfo.etcMdcnCn 
        ) {
            setIsDisabled(true);
        } else {
            setIsDisabled(false);
        }


    },[saveMediInfo])

    if(!mediInfo) return;
    
    return (
        <>

            <HeadSub title="현재 복용중 약물"/>

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                    <div className={style['record-writebox']}>

                        <div className={style['info-box']}>
                            <p><b>약물명</b>을 자유롭게 기재해주세요.</p>
                            <ul>
                                <li>처방약 예시&#41; 타이레놀, 항우울제, 항불안제</li>
                                <li>기타 복용약 예시&#41; 랏토핏, 비타민 B, 홍삼스틱</li>
                            </ul>
                        </div>

                        <div className={style['text-list-box']}>
                            <p>처방약</p>
                            <div className='textarea-box'>
                                <textarea name="crrPrscmdcCn" id="crrPrscmdcCn" placeholder='약물명을 입력해주세요.' value={saveMediInfo.crrPrscmdcCn} onChange={(e) => handleChageText(e.target)}></textarea>
                            </div>
                        </div>
                        <div className={style['text-list-box']}>
                            <p>기타 복용약(영양제, 건강기능식품 등)</p>
                            <div className='textarea-box'>
                                <textarea name="etcMdcnCn" id="etcMdcnCn" placeholder='약물명을 입력해주세요.' value={saveMediInfo.etcMdcnCn} onChange={(e) => handleChageText(e.target)}></textarea>
                            </div>
                        </div>
                       
                       
                    </div>



                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box" data-border-line="top" >
                            <div className="inner-box">

                                <div className='btn-layout' data-btn-num="1">
                                    <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={saveMediHlthInfo} disabled={isDisabled}>
                                        <span>수정 완료</span>
                                    </button>
                                </div>

                            </div>
                    </div>
                    {/* 하단 다음 버튼 영역 :: E */}
                </div>
                <Modal isOpen={saveCompleteOpen} setIsOpen={handleClickSaveCompleteBtn}>
                    <div className='modal-box' data-type="b">
                        <div className='modal-top-box'>
                            <div className='sub-box'>
                                <span>현재 복용중 약물이 수정이 완료되었습니다.</span>
                            </div>
                        </div>
                        <div className="modal-bottom-box">                                
                            <div className='btn-layout'>
                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={handleClickSaveCompleteBtn}>
                                    <span>확인</span>
                                </button>
                            </div> 
                        </div>
                    </div>    
                </Modal>
            </div>
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )}
        </>
    );
};

export default DrugsListWrite;
